import * as CONST from "./actionTypes";

const INIT_STATE = {
  error: "",
  loading: false,
  priceInfo: {},
  AUDLoading: false,
  walletLoading :false
};

const Price = (state = INIT_STATE, action) => {
  switch (action.type) {
    case CONST.GET_PRICE:
      return {
        ...state,
        loading: true,
      };

    case CONST.GET_PRICE_SUCCESSFUL:
      return {
        ...state,
        priceInfo: action.payload || {},
        loading: false,
        error: "",
      };

    case CONST.GET_PRICE_FAILED:
      return {
        ...state,
        priceInfo: {},
        loading: false,
        error: "",
      };

      case CONST.VERIFY_WALLET:
      return {
        ...state,
        walletLoading: true,
      };

    case CONST.VERIFY_WALLET_SUCCESSFUL:
      return {
        ...state,
        walletLoading: false,
        error: "",
      };

    case CONST.VERIFY_WALLET_FAILED:
      return {
        ...state,
        walletLoading: false,
        error: "",
      };

    default:
      return state;
  }
};

export default Price;
